import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  chapterBlocked: {
    id: 'studio.WwSU1m',
    defaultMessage: 'You must complete the previous chapter before starting this one',
  },
});
